import { Button, CollapseIcon, ExpandIcon, Skeleton, Stack } from '@all-manager/design-system-v2';
import { ComponentProps, useId } from "react";
import { ReminderDatabase } from "../../../../types";
import ProviderRemindersList from "../RemindersList/RemindersList";
import { useReminderTabContent } from "./useReminderTabContent";

type Props = {
  currentReminders: ReminderDatabase[];
  currentLoading: boolean;
  pastReminders: ReminderDatabase[];
  pastLoading: boolean;
} & Pick<ComponentProps<typeof ProviderRemindersList>, 'displayProvider' | 'displaySubject'>

const SKELETON_ROWS = ['first', 'second', 'third'];
const SKELETON_HEIGHT = 96;

export default function ReminderTabContent(props: Props) {
  const hook = useReminderTabContent();
  const pastRemindersId = useId();

  if (props.currentLoading || props.pastLoading) {
    return (
      <Stack spacing={1} aria-busy="true" aria-label="Chargement des rappels">
        {SKELETON_ROWS.map((row) => (
          <Skeleton key={row} variant="rounded" height={SKELETON_HEIGHT} />
        ))}
      </Stack>
    );
  }

  return (
    <Stack spacing={2}>
      <ProviderRemindersList
        reminders={props.currentReminders ?? []}
        displayProvider={props.displayProvider}
        displaySubject={props.displaySubject}
      />

      {props.pastReminders && props.pastReminders.length > 0 ? (
        <Stack spacing={1}>
          <Stack direction="row">
            <Button
              variant="text"
              color="default"
              onClick={hook.handleTogglePastReminders}
              endIcon={hook.isPastRemindersOpened ? <CollapseIcon /> : <ExpandIcon />}
              aria-expanded={hook.isPastRemindersOpened}
              aria-controls={pastRemindersId}
            >
              {`Rappels passés (${props.pastReminders.length})`}
            </Button>
          </Stack>
          {hook.isPastRemindersOpened ? (
            <Stack id={pastRemindersId} spacing={1}>
              <ProviderRemindersList
                reminders={props.pastReminders}
                displayProvider={props.displayProvider}
                displaySubject={props.displaySubject}
              />
            </Stack>
          ) : null}
        </Stack>
      ) : null}
    </Stack>
  );
}
